<template>
  <div class="query-block">
    <QueryGroup
      :query="query"
      :delete_btn="false"
    ></QueryGroup>
  </div>
</template>

<script>
  import QueryGroup from './QueryGroup';
  export default {
    name: "QueryBuilder",
    components: { QueryGroup },
    props: ["query"],
  }
</script>